export default __webpack_public_path__ + "static/media/12mas@2x.0d319a58.png";